class ProductApi {
  constructor() {
    this.API_ENDPOINTS = {
      product: "web.ProductService/Product",
      freeP: "web.ProductService/QueryProductFreeShipping",
      freeV: "web.ProductService/QueryVariantFreeShipping",
      wish: "api/v1/my/favorite/update",
      wishList: "api/v1/my/favorite/list",
      delHistory: "web.CustomerService/DeleteBrowsingHistory",
      addHistory: "web.CustomerService/CreateBrowsingHistory",
      history: "web.CustomerService/GetBrowsingHistory",
    };
    this.page = 1;
    this.size = 100;
  }

  // 获取产品详情
  async getProductData(productId) {
    const response = await fetchConnect(this.API_ENDPOINTS.product, "POST", {
      id: productId,
    });
    if (!response.error) {
      return response.data;
    }
    return null;
  }
  // 获取产品是否免邮
  async getPFreeShipping(id) {
    const response = await fetchConnect(this.API_ENDPOINTS.freeP, "POST", {
      id,
    });
    if (!response.error) {
      return response.data?.items;
    }
    return null;
  }

  // 获取变体是否免邮
  async getVFreeShipping(id) {
    const response = await fetchConnect(this.API_ENDPOINTS.freeV, "POST", {
      id,
    });
    if (!response.error) {
      return response.data?.items;
    }
    return null;
  }

  // 添加浏览记录
  async addHistory(url) {
    const response = await fetchConnect(this.API_ENDPOINTS.addHistory, "POST", {
      url,
    });
    if (!response.error) {
      return true;
    }
    return false;
  }

  // 删除浏览记录
  async delHistory(handle) {
    const response = await fetchConnect(this.API_ENDPOINTS.delHistory, "POST", {
      handle,
    });
    if (!response.error) {
      return true;
    }
    return false;
  }

  // 获取浏览记录
  async getHistory(params) {
    const response = await fetchConnect(
      this.API_ENDPOINTS.history,
      "POST",
      params
    );
    if (!response.error) {
      return response.data;
    }
    return [];
  }

  // 添加收藏
  async addWish(sid) {
    const params = {
      page: this.page,
      size: this.size,
      sid,
      favorite: true,
      echo: true,
    };
    const response = await fetchRequest(
      this.API_ENDPOINTS.wish,
      "POST",
      params
    );
    if (!response.error) {
      const total = response.data?.total;
      if (total > 0) {
        return response.data?.products;
      }
      return [];
    }
    return false;
  }

  // 取消收藏
  async cancelWish(sid, param, from) {
    const params = {
      page: param?.page || this.page,
      size: param?.size || this.size,
      sid,
      favorite: false,
      echo: true,
      sort: param?.sort || 0,
    };

    const response = await fetchRequest(
      this.API_ENDPOINTS.wish,
      "POST",
      params
    );
    if (!response.error) {
      const total = response.data?.total;
      if (total > 0) {
        if (from == "formAccount") {
          return response.data;
        }
        return response.data?.products;
      }
      return [];
    }
    return false;
  }

  // 获取收藏列表
  async getWish(param, from) {
    const params = {
      page: param?.page || this.page,
      size: param?.size || this.size,
      sort: param?.sort || 0,
    };
    const response = await fetchRequest(
      this.API_ENDPOINTS.wishList,
      "POST",
      params
    );
    if (!response.error) {
      const total = response.data?.total;
      if (total > 0) {
        if (from == "formAccount") {
          return response.data;
        }
        return response.data?.products;
      }
      return [];
    }
    return [];
  }
}

class ProductLocal {
  constructor(key) {
    this.localKey = key ? key : "wishList";
  }

  async addWish(data) {
    const wishStr = localStorage.getItem(this.localKey);
    const localWishList = theme.inspectJson(wishStr) || [];
    for (let item of data) {
      localWishList.push(item);
    }
    const newList = [...new Set(localWishList)];
    localStorage.setItem(this.localKey, JSON.stringify(newList));
    return newList;
  }

  async cancelWish(data) {
    const wishStr = localStorage.getItem(this.localKey);
    const localWishList = theme.inspectJson(wishStr) || [];
    for (let item of data) {
      const index = localWishList?.findIndex((wish) => wish == item);
      if (index != -1) {
        localWishList.splice(index, 1);
      }
    }
    const newList = [...new Set(localWishList)];
    localStorage.setItem(this.localKey, JSON.stringify(newList));
    return newList;
  }

  async getWish() {
    const wishStr = localStorage.getItem(this.localKey);
    const localWishList = theme.inspectJson(wishStr) || [];
    return localWishList;
  }

  async clear() {
    localStorage.removeItem(this.localKey);
    return true;
  }
}

class ProductAdapter {
  constructor() {
    var token = theme.getCookies("token");
    const loginFlag = token ?? null;
    this.isLogin = loginFlag ? true : false;
    this.localStorage = new ProductLocal();
    this.apiStorage = new ProductApi();
    this.localWish = new ProductLocal("localWishList");
    // this.storage = this.isLogin ? this.apiStorage : this.localStorage;
  }

  // 处理参数
  handleParams(data) {
    const typeStr = Object.prototype.toString.call(data);
    const list = [];
    if (typeStr === "[object Array]") {
      for (let item of data) {
        const id = String(item?.product_id || item?.id);
        list.push(id);
      }
    } else if (typeStr === "[object Object]") {
      const id = String(data?.product_id || data?.id);
      list.push(id);
    }
    return list;
  }

  // 显示界面中相同产品是否收藏
  showIsWish(sid, isShow) {
    // 遍历sid，获取class=addto-wishlist, data-id为sid当前值的元素
    if (Array.isArray(sid)) {
      sid.forEach((id) => {
        const wishlistElements = document.querySelectorAll(
          `.addto-wishlist[data-id="${id}"]`
        );
        wishlistElements.forEach((element) => {
          // 找到元素后可以进行操作，例如添加loading状态
          const atIcon = element.querySelector(".at");
          const noWishImg = element.querySelector(".no-wish");
          if (isShow) {
            atIcon ? (atIcon.style.display = "inline") : "";
            noWishImg ? (noWishImg.style.display = "none") : "";
          } else {
            atIcon ? (atIcon.style.display = "none") : "";
            noWishImg ? (noWishImg.style.display = "inline") : "";
          }
        });
      });
    }
  }

  // 加入收藏
  async addWish(data) {
    const list = this.handleParams(data);
    if (this.isLogin) {
      const result = await this.apiStorage.addWish(list);
      if (result) {
        this.localStorage.addWish(list);
        this.showIsWish(list, true);
        return result;
      }
    }
    this.localWish.addWish(list);
    this.showIsWish(list, true);
    return this.localStorage.addWish(list);
  }

  // 取消收藏
  async cancelWish(data) {
    const list = this.handleParams(data);
    if (this.isLogin) {
      const result = await this.apiStorage.cancelWish(list);
      if (result) {
        this.showIsWish(list, false);
        this.localStorage.cancelWish(list);
        return result;
      }
    }
    this.localWish.cancelWish(list);
    this.showIsWish(list, false);
    return this.localStorage.cancelWish(list);
  }

  // 获取本地列表
  getLocalWish() {
    return this.localWish.getWish();
  }

  // 清空本地列表
  clearLocalWish() {
    return this.localWish.clear();
  }

  // 获取收藏列表
  getWish() {
    return this.isLogin
      ? this.apiStorage.getWish()
      : this.localStorage.getWish();
  }
}
